module.exports = __webpack_public_path__ + "img/map.44ab302e.jpg";